export default "__VITE_ASSET__fc6824b5__"